import { useMemo } from "react";

interface ImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> {
  src: string | null | undefined;
}

/**
 * Image component that can handle both regular image URLs and SVG text strings.
 * When the src starts with '<svg', it creates a blob URL for proper display.
 */
export function Image({ src, ...props }: ImageProps) {
  const imageSrc = useMemo(() => {
    if (!src) return undefined;

    // Handle SVG text by creating a blob URL
    if (src.startsWith("<svg")) {
      return URL.createObjectURL(new Blob([src], { type: "image/svg+xml" }));
    }

    // Handle regular image URLs (including base64)
    return src;
  }, [src]);

  if (!src) return null;

  return <img {...props} src={imageSrc} alt={props.alt ?? "image"} />;
}
